export enum LayoutActions {
  SET_SIDEBAR_VISIBILITY = 'layout/SET_SIDEBAR_VISIBILITY',
  SET_UNPURCHASED_MODAL_VISIBILITY = 'layout/SET_UNPURCHASED_MODAL_VISIBILITY',
}
